var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8521_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1789 5.17891L20.7094 6.66948C21.601 9.1749 21.0455 12.0839 19.0369 14.0924C17.1917 15.9376 14.5866 16.5566 12.2325 15.9537L9.15067 19.0356C7.73639 20.4499 5.44339 20.4499 4.02911 19.0356C2.61483 17.6213 2.61483 15.3283 4.02911 13.914L7.11097 10.8322C6.50811 8.47811 7.12705 5.87295 8.97224 4.02776C10.9808 2.01922 13.8898 1.46366 16.3952 2.3553L17.8858 2.88578L14.0938 6.67775C13.4606 7.31098 13.4606 8.33766 14.0938 8.97089C14.727 9.60412 15.7537 9.60412 16.3869 8.97089L20.1789 5.17891ZM19.1216 9.06469L17.8011 10.3851C16.3869 11.7994 14.0939 11.7994 12.6796 10.3851C11.2653 8.97082 11.2653 6.67782 12.6796 5.26354L14 3.94313C12.6912 3.94432 11.3839 4.44457 10.3865 5.44197C8.9442 6.88423 8.54147 8.97465 9.18402 10.7801L9.39594 11.3756L5.44333 15.3282C4.81009 15.9615 4.81009 16.9881 5.44333 17.6214C6.07656 18.2546 7.10323 18.2546 7.73646 17.6214L11.6891 13.6688L12.2845 13.8807C14.09 14.5232 16.1805 14.1205 17.6227 12.6782C18.6201 11.6808 19.1204 10.3734 19.1216 9.06469Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8521_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.a903dc69b3c3e88f1bf6ae23884dcf21.svg";
export { ForwardRef as ReactComponent };